<template>
  <v-container fluid v-resize="onResize">
    <v-data-table
        dense
        :headers="getColumns"
        :items="loading ? [] : itemList"
        item-key="id"
        class="elevation-1"
        :options.sync="options"
        :server-items-length="totalRecords"
        @update:options="updateOptions"
        :loading="loading"
        :footer-props="{
            'items-per-page-options': [20, 50, 100, 250]
          }"
        :height="windowSize.y - subtractHeight"
        fixed-header
        :item-class="itemRowBackground"
        hide-default-footer
    >
      <template v-slot:top>
        <v-toolbar ref="RefListTop" height="64">
          <v-container fluid>
            <v-row class="mt-10">
                <v-text-field
                    v-if="userId === null"
                    v-model="searchTerm"
                    label="Search user, employee, department"
                    clearable
                    @input="onUpdateSearchTerm"
                ></v-text-field>
              <v-spacer></v-spacer>
                <v-text-field type="month" v-model="current_date" clearable label="Date" @input="onUpdateFilters()"></v-text-field>
              <v-spacer></v-spacer>
              <v-checkbox
                  v-model="onlyActiveUser"
                  label="only active user"
                  @change="onUpdateFilters"
              ></v-checkbox>
            </v-row>
          </v-container>
        </v-toolbar>
      </template>
      <template v-slot:item.human_user="{ item }">
        {{ item.human_user__user }} ({{ item.human_user__employee_number }})
      </template>
      <template v-slot:item.holiday_current_available="{ item }">
        {{ item.holiday_current_available }}
      </template>
    </v-data-table>
    <router-view></router-view>
  </v-container>
</template>

<script>
import {debounce} from "debounce"
import {mapGetters, mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';


export default {
  name: 'CalendarDateUserStatisticBegin',
  props: {
    subtractHeight: {type: [Number], default: 180},
    height: {type: [Number], default: window.innerHeight},
    userId: {default: null},
    dto_model: {type: [String], default: 'CalendarDateUserStatisticBeginDTO'},
  },

  components: {
  },

  computed: {
    ...mapGetters('CalendarDateUserStatisticBegin', ['getColumns']),
    ...mapFields('CalendarDateUserStatisticBegin', ['message_error', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm',
      'isAlive', 'action_loading', 'filters', 'local_phrase']),
  },
  methods: {
    ...mapActions('CalendarDateUserStatisticBegin', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchSaveItemField', 'fetchOrderItemList',
      'fetchActionSelectedItem', 'fetchActionItem']),

    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },

    itemRowBackground: function (item) {
      // console.log('row click', item)
      if (item.error_message != null)
        return "event_error"
      else
        return "event_" + item.event
    },

    getEventColor: function (item) {
      return this.local_phrase[item.event].color
    },

    updateOptions() {
      // console.log('updateOptions', this.userId)
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onUpdateFilters() {
      // console.log('updateOptions', this.userId, )
      this.options.page = 1

      this.filters = {}

      if (this.userId !== null)
        this.filters['user_id'] = this.userId

      if (this.current_date) {
        console.log('current_date', this.current_date)
        this.filters['current_date'] = this.current_date
      }
      else
        this.filters['current_date'] = null

      if (this.onlyActiveUser === true)
        this.filters['only_active_user'] = true

      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    },

    onRemoveItems() {
      this.fetchDeleteSelectedItem()
    },

    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm', this.filters)
      this.options.page = 1
      this.fetchItemList({to_consumer: this.dto_model, from_consumer: this.dto_model})
    }, 800),

  },

  async mounted() {
    // console.log('mounted')
    this.briefView = this.userId != null
    this.searchTerm = null
    this.current_date = new Date().toISOString().slice(0, 10)
    this.onUpdateFilters()
  },

  data() {
    return {
      windowSize: {x: 0, y: 0,},
      current_date: null,
      onlyActiveUser: true,
    }
  }
}
</script>

<style>
.row_even {
  background-color: white !important;
}

.event_working, .event_work_kug {
  background-color: #E3F2FD !important;
}

.event_time_correction {
  background-color: #E1F5FE !important;
}

.event_holiday, .event_holiday_extra {
  background-color: #E8F5E9 !important;
}

.event_sick, .event_sick_with_child, .event_sick_kug {
  background-color: #FFF8E1 !important;
}

.event_error {
  background-color: #FFEBEE !important;
}

</style>
